var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"news-breadcrumb",attrs:{"separator":">"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: _vm.fromPath }}},[_vm._v("新闻列表")]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.pageName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }